import Icon from 'Components/_NewElements/Icon';
import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import InfoPopover from 'Components/InfoPopover';
import ToolTip from 'Components/ToolTip';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType } from 'Utility/documentHandling';
import { formatSeizureClassification } from '../../../../../Seizure/utils';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const SeizureTypeHistory = (props: IHistoryContext<IDocumentWithTypeV2<'seizureType'>>): React.JSX.Element => {
  const { startEdit, fm, documents = [] } = props;
  const prefix = 'diagnosis.epilepsy.seizureType.'; // for localization

  return (
    <React.Fragment>
      <HistoryRow
        headerText={fm('diagnosis.epilepsy.seizureType.title')}
        rowButton={startEdit ? newButton('seizureType', startEdit({}, 'seizureType'), 'general.new', 15) : undefined}
      >
        <HistoryRowListing
          headers={
            <>
              <Item xs={4}>{fm(prefix + 'seizureFreeDescription')}</Item>
              <Item xs={3}>
                {fm(prefix + 'seizureNameByPatient')}
                <span style={{ marginLeft: '1rem' }}>
                  <InfoPopover text="diagnosis.epilepsy.seizureType.seizureNameByPatientInfotext" color="primary" />
                </span>
              </Item>
              <Item xs={3}>{fm(prefix + 'seizureClassification')}</Item>
              <Item xs={2}>{fm(prefix + 'firstOccurenceDate')}</Item>
            </>
          }
          contentFormat={doc => (
            <>
              <Item xs={4}>{doc.freeDescription ?? '-'}</Item>
              <Item xs={3}>{doc.nameByPatient ?? '-'}</Item>
              <Item xs={3}>
                {doc.classification
                  ? formatSeizureClassification(doc.classification.classification, 'long', true)
                  : '-'}
              </Item>

              <Item xs={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ whiteSpace: 'nowrap' }}>
                  {doc.firstOccurenceDate
                    ? formatPartialDate(doc.firstOccurenceDate) !== ''
                      ? formatPartialDate(doc.firstOccurenceDate)
                      : doc.firstOccurenceDate.filter(n => n).join('/')
                    : '-'}
                </div>
                {doc.visibleToPatient && (
                  <div style={{ position: 'relative', left: '25%' }}>
                    <ToolTip
                      title={fm(prefix + 'visibleForPatient')}
                      content={<Icon icon="visibility" />}
                      hover={true}
                    />
                  </div>
                )}
              </Item>
            </>
          )}
          documents={filterDocumentsByType(documents, ['seizureType'])}
          dateFieldName={'firstOccurenceDate'}
          collapse={false}
          makeControls
          historyRowControls={d => (startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : <></>)}
        />
      </HistoryRow>
    </React.Fragment>
  );
};

export default SeizureTypeHistory;
